(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('PhoneCallCheckSearch', PhoneCallCheckSearch);

    PhoneCallCheckSearch.$inject = ['$resource'];

    function PhoneCallCheckSearch($resource) {
        var resourceUrl =  'api/_search/phone-call-checks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
